export default {
	STARTED: 'started',
	SUBMITTED: 'submitted',
}
